module.exports = __webpack_public_path__ + "img/chevron-right.aaa8b0eb.svg";